import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

import { makeStyles, Typography, Container, useTheme } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

import ScrollToTop from '../../../../common/ScrollToTop';
import { Link, useLocation } from 'react-router-dom';
import URLParams from '../../../../../utils/getParams';
import { changeLanguage, isEnglish } from '../../../../../utils/lang';
import { isTabiCube } from '../common/TabiCube';
import AirportTransferTaxiHeader from '../common/Header';
import { HelmetProvider } from 'react-helmet-async';
import AdobeAnalyticsScript from '../../../Common/AdobeAnalyticsScript';

const useStyles = makeStyles((theme) => ({
  guide: {
    marginTop: 10,
  },
  iconInfo: {
    fontSize: '22px',
    verticalAlign: 'top',
  },
  typography: {
    marginTop: '10px',
  },
  underline: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
  },
  logoArea: {
    marginTop: '10px'
  }
}));

/** タクシーの仮予約完了後の画面のコンポーネント。 */
const Success: React.FC = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const classes = useStyles(theme);
  const location = useLocation();

  // 会社ごとの切り分けが必要になったらコメントアウトを外す
  const searchParams = new URLParams(location.search);
  // const company = convertStringToTaxiCompany(searchParams.getStringParam('company') || '' );

  // 言語設定をする
  changeLanguage(searchParams, i18n);
  /** 言語設定。 */
  const lang = i18n.language;
  /** referrerパラメーターの値。 */
  const referrer = searchParams.getStringParam('referrer');
  /** 旅CUBEモードであるかを表すフラグ。 */
  const tabiCube = isTabiCube(referrer || '');
  /** ページタイトル。 */
  const title = tabiCube ? t('tabicube') : t('title');

  /** メールが届かない場合の案内画面ページに渡すパラメーター。 */
  const params = new URLSearchParams({
    lang: lang,
    referrer: referrer === null ? '' : referrer,
  });
  /** メールが届かない場合の案内画面ページへのパス。 */
  const path = `/booking-taxi/unreceived?${params.toString()}`;

  const AutomaticDeliveryNotice: React.FC = () => {
    if (isEnglish(lang)) {
      return (
        <Typography color='error' className={classes.guide}>
          <InfoIcon color='error' className={classes.iconInfo}/>
            If the auto generated email is not received, you may also confirm&nbsp;
          <Link to={path}>
            <span className={classes.underline}>here.</span>
          </Link>
        </Typography>
      )
    } else {
      return (
        <Typography color='error' className={classes.guide}>
          <InfoIcon color='error' className={classes.iconInfo}/>
          自動配信メールが届かないお客様は
          <Link to={path}>
            <span className={classes.underline}>こちら</span>
          </Link>
          もご確認ください。
        </Typography>
      )
    }
  }

  return (
    <div>
      <HelmetProvider>
        <Helmet>
          {/* ページタイトルを設定する。 */}
          <title>{title}</title>
          {/* Adobe Analyticsでタクシー予約画面のアクセス数の集計をする。 */}
          {/* <script type="application/javascript">
            s.pageName=location.origin+&quot;/booking-taxi/success&quot;;
            s.t();
          </script> */}
        </Helmet>
      </HelmetProvider>
      <AdobeAnalyticsScript path="/booking-taxi/success"/>
      {/* 画面遷移時に画面トップへ遷移させるためのコンポーネント。 */}
      <ScrollToTop />
      {/* ヘッダー部分（常にハイヤー・タクシー予約に統一） */}
      <AirportTransferTaxiHeader tabiCube={tabiCube} />
      <Container maxWidth="md">
        <Typography color='primary' className={classes.typography}>
          {t('taxi:temporary_reservation_success_string_1')}<br/>
          {t('taxi:temporary_reservation_success_string_2')}
        </Typography>
        <Typography color='error' className={classes.typography}>
          {tabiCube?
            <>
              {t('taxi:temporary_reservation_success_string_4')}
            </>
            :
            <>
              {t('taxi:temporary_reservation_success_string_3')}
            </>
          }
        </Typography>
        {/* 自動配信メールが届いていない場合の案内を開くテキスト部分。 */}
        <AutomaticDeliveryNotice/>
      </Container>
    </div>
  )
};

export default Success;
